import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("t24_cart") || "[]");
    } catch (e) {
      return [];
    }
  });
  const [pending, setPending] = useState(null); // item awaiting extras modal

  useEffect(() => {
    localStorage.setItem("t24_cart", JSON.stringify(items));
  }, [items]);

  const _add = (list, product) => {
    const existing = list.find((i) => i.id === product.id);
    if (existing) {
      return list.map((i) => (i.id === product.id ? { ...i, qty: i.qty + (product.qty || 1) } : i));
    }
    return [...list, { ...product, qty: product.qty || 1 }];
  };

  // open extras modal for a meal
  const requestAdd = (item) => setPending(item);

  // confirm from modal: add meal + chosen extras
  const confirmAdd = (extras = []) => {
    setItems((prev) => {
      let next = _add(prev, pending);
      extras.forEach((ex) => (next = _add(next, ex)));
      return next;
    });
    setPending(null);
  };

  const closeModal = () => setPending(null);

  // direct add (no modal) — for desserts/sweets boxes
  const addItem = (product) => setItems((prev) => _add(prev, product));

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const updateQty = (id, qty) => {
    if (qty <= 0) return removeItem(id);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
  };
  const clearCart = () => setItems([]);

  const count = useMemo(() => items.reduce((a, i) => a + i.qty, 0), [items]);
  const subtotal = useMemo(() => items.reduce((a, i) => a + i.qty * i.price, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, pending, requestAdd, confirmAdd, closeModal, addItem, removeItem, updateQty, clearCart, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
};
